module.exports = __webpack_public_path__ + "static/media/shadow.2a3552b6.jpg";